import { EBaseApiTags } from 'shared/typings';

import { enhancedApi } from './codegen.api';

export const accountApi = enhancedApi.enhanceEndpoints({
	addTagTypes: [EBaseApiTags.PROFILE, EBaseApiTags.CONFIG, EBaseApiTags.ACCOUNT_SETTINGS],
	endpoints: {
		accountLanguageCreate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.CONFIG]),
		},
		accountProfileRetrieve: {
			providesTags: [EBaseApiTags.PROFILE],
		},
		accountSettingsRetrieve: {
			providesTags: [EBaseApiTags.ACCOUNT_SETTINGS],
		},
		accountSettingsUpdate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.ACCOUNT_SETTINGS]),
		},
		accountSettingsPartialUpdate: {
			invalidatesTags: (_, error) => (error ? [] : [EBaseApiTags.ACCOUNT_SETTINGS]),
		},
	},
});
export const {
	useAccountLanguageCreateMutation,
	useAccountProfileRetrieveQuery,
	useAccountSettingsUpdateMutation,
	useAccountSettingsRetrieveQuery,
	useAccountSettingsPartialUpdateMutation,
} = accountApi;
